export default __webpack_public_path__ + "static/media/whatsapp.e67d63fd.svg";